import { useMutation } from "react-query";
import http from "infra/http";
import { EmpresaResponse } from "core/resources/types/empresa";

function useSavePessoaJuridicaUnidade(unidadeId: string, id?: string | null) {
  return useMutation(
    (data: EmpresaResponse) => {

      const _data = data.pessoaId ? { pessoaId: data.pessoaId } : data

      if (!data.pessoaId) {
        data.pessoa.contatos = Array.isArray(data.pessoa.contatos) ? data.pessoa.contatos : [];
      }

      if (!id) {
        return http.post(`/v1/unidades/${unidadeId}/pessoas-juridicas`, _data);
      }

      return http.put(
        `/v1/unidades/${unidadeId}/pessoas-juridicas/${id}`,
        data
      );
    },
    { retry: false }
  );
}

export default useSavePessoaJuridicaUnidade;
